<sw-modal v-if="showModal"
          :title="modalTitle"
          class="llm-assignment-form"
          @modal-close="onCancel">
    <sw-container>
        <sw-text-field v-model="entity.purpose"
                       :label="$tc('TopdataLlmConnectSW6.assignment.purposeLabel')"
                       :placeholder="$tc('TopdataLlmConnectSW6.assignment.purposePlaceholder')"
                       :disabled="!isNew"
                       required>
        </sw-text-field>
        <sw-text-field v-model="entity.owner"
                       :label="$tc('TopdataLlmConnectSW6.assignment.ownerLabel')">
        </sw-text-field>
        <sw-text-field v-model="entity.description"
                       :label="$tc('TopdataLlmConnectSW6.assignment.descriptionLabel')">
        </sw-text-field>

        <div class="llm-assignment-form__chain">
            <h4>{{ $tc('TopdataLlmConnectSW6.assignment.chainLabel') }}</h4>

            <div v-for="(entry, index) in chainEntries"
                 :key="index"
                 class="llm-assignment-form__chain-row">
                <mt-select
                    v-model="entry.prefix"
                    :label="index === 0 ? $tc('TopdataLlmConnectSW6.assignment.firstRowLabel') : ''"
                    :options="prefixOptions">
                </mt-select>
                <sw-text-field v-model="entry.model"
                               :label="$tc('TopdataLlmConnectSW6.assignment.modelLabel')"
                               placeholder="gpt-5.4-nano">
                </sw-text-field>
                <sw-button
                    v-if="chainEntries.length > 1"
                    variant="danger"
                    square
                    size="small"
                    @click="removeRow(index)">
                    <sw-icon name="regular-times-s" small></sw-icon>
                </sw-button>
            </div>

            <sw-button variant="ghost" size="small" @click="addRow">
                {{ $tc('TopdataLlmConnectSW6.assignment.addEntryButton') }}
            </sw-button>
        </div>

        <sw-switch-field v-model="entity.active"
                         :label="$tc('TopdataLlmConnectSW6.assignment.activeLabel')">
        </sw-switch-field>
    </sw-container>

    <template #modal-footer>
        <sw-button size="small" @click="onCancel">
            {{ $tc('global.default.cancel') }}
        </sw-button>
        <sw-button variant="primary" @click="onSave" :isLoading="isSaving">
            {{ $tc('global.default.save') }}
        </sw-button>
    </template>
</sw-modal>